import { AxiosError } from 'axios'
import { toast } from 'sonner'

export function handleNetworkErrorException(e: AxiosError): void {
  console.log('Network error', e)
}

export function handleUnauthorizedException(e: AxiosError): void {
  console.log('Unauthorized exception', e)
  localStorage.removeItem('access_token')
  localStorage.removeItem('user')
  localStorage.removeItem('system_uid')
  window.location.href = '/login'
}

export function handleForbiddenException(e: AxiosError): void {
  console.log('Forbidden exception', e)
  const message = (e.response?.data as { message?: string } | undefined)?.message
  // One toast however many requests on the page fail the same way.
  toast.error(message?.startsWith('Forbidden') || !message ? "You don't have permission to do this." : message, {
    id: 'forbidden',
  })
}
